module.exports = __webpack_public_path__ + "img/img4.84b4c8d7.png";